import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, map, tap } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";


environment;
@Injectable({
  providedIn: "root",
})
export class ClientApplicationService extends UnsubscribeOnDestroyAdapter {
  private readonly API_URL = environment.serverUrl;
  constructor(private httpClient: HttpClient) {
    super();
  }
  //subject//
  dataEmitter = new Subject<any>();
  raisedDataEmitterEvent(data: any) {
    this.dataEmitter.next(data);
  }

  //GET APPLICATION//
  ///v2/in-site/client/:clientId/applications/:organisationId
  getApplicationsList(clientId: String): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/0`
    );
  }
  //get Settings:
  // {{host}}/v2/in-site/client/:clientId/applications/:applicationId/settings

  getSettings(userId, appId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${userId}/applications/${appId}/settings`
    );
  }
  //{{host}}/v2/in-site/client/:clientId/applications/:applicationId/settings
  setApplicationAuthSettings(data, model) {
    const { userId, appId } = data;
    return this.httpClient.put(
      this.API_URL +
      `v2/in-site/client/${userId}/applications/${appId}/settings`,
      model
    );
  }
  //{{host}}/v2/in-site/client/:clientId/applications/:applicationId/hooks
  getHooks(appId, clientId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/hooks`
    );
  }
  //{{host}}/v2/in-site/client/:clientId/applications/:applicationId/hooks
  updateHook(data) {
    const { userId, appId, payload } = data;
    console.log(payload);
    return this.httpClient.put(
      this.API_URL + `v2/in-site/client/${userId}/applications/${appId}/hooks`,
      payload
    );
  }
  //{{host}}/v2/in-site/client/:clientId/applications/:applicationId/links
  getLinks(appId, clientId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/links`
    );
  }
  updateLinks(clientId: string, appId: string, model) {
    return this.httpClient.put(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/hooks`,
      model
    );
  }
  //{{host}}/v2/in-site/client/:clientId/applications/:applicationId/roles
  //Get Roles
  getRoles(data): Observable<any> {
    const { clientId, appId, fetchRolesOfClientForAdmin, organisationId } = data;
    if (fetchRolesOfClientForAdmin) {
      return this.httpClient.get(
        `${this.API_URL}v2/in-site/admin/${organisationId}/application/${appId}/roles/${clientId}/`
      );
    }
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/roles`
    );
  }
  //post Roles
  // {{host}}/v2/in-site/client/:clientId/applications/:applicationId/roles
  addRole(clientId, appId, payload): Observable<any> {
    return this.httpClient.post(
      this.API_URL +
      `v2/in-site/client/${clientId}/applications/${appId}/roles/`,
      payload
    );
  }
  //updateRole
  // {{host}}/v2/in-site/client/:clientId/applications/:applicationId/roles-update/:roleId
  updateRole(data) {
    const { clientId, appId, roleId, payload } = data;
    // console.log(payload)

    console.log(payload)
    return this.httpClient.put(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/roles-update/${roleId}`,
      payload.role
    );
  }

  //deleteRole
  // {{host}}/v2/in-site/client/:clientId/applications/:applicationId/roles/:roleId
  deleteRole(clientId, appId, roleId): Observable<any> {
    return this.httpClient.delete(
      `${this.API_URL}v2/in-site/client/${clientId}/applications/${appId}/roles/${roleId}`
    );
  }
  // {{host}}/v2/in-site/client/:clientId/users/applications/:userId
  getUserAuthorization(clientId, userId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/users/applications/${userId}`
    );
  }
  //{{host}}/v2/in-site/client/:clientId/users/login-history/:userId
  getUserHistory(clientId, userId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/users/login-history/${userId}`
    );
  }
  //{{host}}/v2/in-site/client/:clientId/users/account-history/:userId
  getUserLog(clientId, userId): Observable<any> {
    return this.httpClient.get(
      `${this.API_URL}v2/in-site/client/${clientId}/users/account-history/${userId}`
    ).pipe(
      map((response: any) => {
        response.data.userLog = response.data.userLog.map(item => {
          // Merge userDetail and log objects
          return { ...item.userDetail, ...item.log };
        });
        return response;
      })
    );;
  }
  setLogicalAccess(logicalAccessData: { isSet: boolean, URL: string }, ids: { clientId: string, applicationId: string }) {
    const { clientId, applicationId } = ids;
    return this.httpClient.post(`${this.API_URL}v2/in-site/client/${clientId}/applications/${applicationId}/logical-access`, logicalAccessData)
  }
  getLogicalAccess(ids: { clientId: string, applicationId: string }) {

    const { clientId, applicationId } = ids;
    return this.httpClient.get(`${this.API_URL}v2/in-site/client/${clientId}/applications/${applicationId}/logical-access`)

  }

  setPermissionWebHook(model: { application_id: string, active: boolean, url: string },
    ids: { applicationId: string, clientId: string }) {
    const { applicationId, clientId } = ids;
    return this.httpClient.post(`${this.API_URL}v2/in-site/client/${clientId}/applications/${applicationId}/permission-hook`, model)
  }

  getPermissionWebHook(ids: { applicationId: string, clientId: string }) {

    const { applicationId, clientId } = ids;
    return this.httpClient.get(`${this.API_URL}v2/in-site/client/${clientId}/applications/${applicationId}/permission-hook`)

  }
}
